<template>
  <div
    id="app"
    :class="'lang_'+langKey"
  >
    <router-view />

    <div
      v-if="$isProduction"
      v-show="hasResolutonOverlay"
      id="resolutionOverlay"
    >
      <p v-html="$t('resolution_notification')" />
    </div>

    <div
      id="orientationRotateMsg"
      class="hidden"
    >
      <p
        class="animated fadeInUp"
        v-html="$t('rotate_notification')"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      hasResolutonOverlay: false
    }
  },
  computed: {
    langKey() {
      return this.$store.getters.langKey
    },

    screenRatio: {
      set(val) {
        this.$store.commit('screenRatio', val)
      },
      get() {
        return this.$store.getters.screenRatio
      }
    }
  },
  created() {
    this.$store.commit('setContinueSound', this.getHowlBtnSound('continueButton'))
    window.addEventListener('resize', this.handleScreenSize)
  },
  mounted() {
    this.checkAspectRatio()
  },
  destroyed() {
    window.removeEventListener('resize', this.handleScreenSize)
  },
  methods: {
    handleScreenSize() {
      this.checkAspectRatio()
    },

    checkAspectRatio() {
      const windowWidth = window.innerWidth
      if (windowWidth <= 1024) return

      this.screenRatio = windowWidth / window.innerHeight
      this.hasResolutonOverlay = false

      if (this.screenRatio < 1.7 || this.screenRatio >= 1.8) {
        document.body.classList.add('overflowed')
        if (this.screenRatio >= 1.8 && this.$route.name !== 'login') {
          this.hasResolutonOverlay = true
          setTimeout(() => {
            this.hasResolutonOverlay = false
          }, 10 * 1000)
        }
      }
      else {
        document.body.classList.remove('overflowed')
      }
    }
  }
}
</script>

<style src="@/assets/stylesheets/app.scss" lang="scss"></style>
